import { render, staticRenderFns } from "./Attachments_Global_Progress_FileItem.vue?vue&type=template&id=6cfd8075&"
import script from "./Attachments_Global_Progress_FileItem.vue?vue&type=script&lang=js&"
export * from "./Attachments_Global_Progress_FileItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports